/**
 * Wires up the mobile "Load more products" button to the results-list
 * component's public loadNextPage() API (see paginated-list.js). Delegates
 * all fetching/rendering to the existing pagination component — this file
 * only handles the button's own loading state and the "Viewing X of Y" text.
 */
function initLoadMoreButtons() {
  const buttons = document.querySelectorAll('[data-load-more-button]:not([data-initialized])');

  buttons.forEach((button) => {
    button.setAttribute('data-initialized', '');
    const container = button.closest('.product-grid-load-more');
    const countEl = container?.querySelector('[data-load-more-count]');
    const resultsList = button.closest('results-list');
    if (!resultsList) return;

    const totalItems = Number(button.dataset.total || 0);
    const pageSize = Number(button.dataset.pageSize || 0);
    let shownCount = Math.min(
      Number(resultsList.querySelector('[ref="grid"]')?.children.length || pageSize),
      totalItems
    );

    button.addEventListener('click', async () => {
      if (button.disabled) return;
      const originalText = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        await resultsList.loadNextPage();
        shownCount = Math.min(shownCount + pageSize, totalItems);
        if (countEl) {
          countEl.textContent = countEl.textContent.replace(/\d+/, String(shownCount));
        }
        if (!resultsList.hasNextPage) {
          button.hidden = true;
        }
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoadMoreButtons);
} else {
  initLoadMoreButtons();
}

// Re-initialize after Shopify section reloads (theme editor).
document.addEventListener('shopify:section:load', initLoadMoreButtons);
